var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"aspect-ratio-box",style:(`padding-bottom:${_vm.runStr(_vm.aspect)}`),on:{"click":function($event){return _vm.$emit('click')}}},[_c('div',{staticClass:"aspect-ratio-content"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }